import { createSvgIcon } from "@mui/material/utils";

/**
 * Policies icon.
 *
 * ![PoliciesIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi44OCAtMi44OCAyOS43NiAyOS43NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiMxMDE4MjgiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjRweCI+PHBhdGggZD0iTTE0IDExSDhNMTAgMTVIOE0xNiA3SDhNMjAgMTBWNi44QzIwIDUuMTE5ODQgMjAgNC4yNzk3NiAxOS42NzMgMy42MzgwM0MxOS4zODU0IDMuMDczNTQgMTguOTI2NSAyLjYxNDYgMTguMzYyIDIuMzI2OThDMTcuNzIwMiAyIDE2Ljg4MDIgMiAxNS4yIDJIOC44QzcuMTE5ODQgMiA2LjI3OTc2IDIgNS42MzgwMyAyLjMyNjk4QzUuMDczNTQgMi42MTQ2IDQuNjE0NiAzLjA3MzU0IDQuMzI2OTggMy42MzgwM0M0IDQuMjc5NzYgNCA1LjExOTg0IDQgNi44VjE3LjJDNCAxOC44ODAyIDQgMTkuNzIwMiA0LjMyNjk4IDIwLjM2MkM0LjYxNDYgMjAuOTI2NSA1LjA3MzU0IDIxLjM4NTQgNS42MzgwMyAyMS42NzNDNi4yNzk3NiAyMiA3LjExOTg0IDIyIDguOCAyMkgxMi41TTE4IDIxQzE4IDIxIDIxIDE5LjU3MDEgMjEgMTcuNDI1MlYxNC45MjI5TDE4LjgxMjQgMTQuMTQxMkMxOC4yODY4IDEzLjk1MjkgMTcuNzEyIDEzLjk1MjkgMTcuMTg2NCAxNC4xNDEyTDE1IDE0LjkyMjlWMTcuNDI1MkMxNSAxOS41NzAxIDE4IDIxIDE4IDIxWiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD48L3N2Zz4=)
 */
const PoliciesIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <path
      d="M14 11H8M10 15H8M16 7H8M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Policies"
);

export default PoliciesIcon;
